import Python from "../assets/skills/python.png";
import Javascript from "../assets/skills/js.png";
import CSS from "../assets/skills/css-3.png";
import React from "../assets/skills/react.png";
import Nodejs from "../assets/skills/nodejs.png";
import Typescript from "../assets/skills/typescript.png";
import HTML from "../assets/skills/html-5.png";

export const skills = [
  {
    key: 0,
    icon: Python,
    alt: "Python Icone",
    description: "Python (Flask, Django)",
  },
  {
    key: 1,
    icon: Javascript,
    alt: "Javascript Icone",
    description: "Javascript",
  },
  {
    key: 2,
    icon: CSS,
    alt: "CSS Icone",
    description: "CSS",
  },
  {
    key: 3,
    icon: Typescript,
    alt: "Typescript Icone",
    description: "Typescript",
  },
  {
    key: 4,
    icon: React,
    alt: "React Icone",
    description: "React",
  },
  {
    key: 5,
    icon: Nodejs,
    alt: "Node.js Icone",
    description: "Node.js (Express)",
  },
  {
    key: 6,
    icon: HTML,
    alt: "HTML Icone",
    description: "HTML",
  },
];
